import useFetchHelpCenter from 'app/hooks/fetch/useFetchHelpCenter';

export default function useContactFormISI() {
  const { data: helpCenter } = useFetchHelpCenter();
  return !!helpCenter?.contact_forms_include_isi;
}
